// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"B8-z","refreshPageWarning":"C8-z","redirectMessageText":"D8-z"};